module.exports = __webpack_public_path__ + "img/step20_1_mfp_locate_refeed_preventers.a4c9045a.png";